import addToCartBackOrderModel from './addToCartBackOrderModel';
import addGiftBackOrderModel from './addGiftBackOrderModel';

export default class AddToCartBackOrder {
	constructor(modalInstance = {}) {
		this.modalInstance = modalInstance;
		this.addToCartModalId = 'addToCartBackOrder';
		this.cartEntries = [];

		if (this.modalInstance.modal) {
			this.modalHtml = this.modalInstance.modal.element;
			this.addToCartBackOrderButton = this.modalHtml.querySelector(
				'#addToCartBackOrderCheckout',
			);

			if (this.addToCartBackOrderButton) {
				this.isPremiumGift =
					this.addToCartBackOrderButton.dataset.premiumGift === 'true';
				this.modalTrigger();
			}
		}
	}

	modalTrigger() {
		this.addToCartBackOrderButton.addEventListener('click', e => {
			e.preventDefault();

			this.getBackOrderData(e);
			this.getReplacementProductData();
			this.addToBasketCheck();
		});
	}

	addToBasketCheck() {
		if (this.cartEntries.length) {
			this.populateAddToCartModal();
		} else {
			this.modalInstance.modal.hide();
		}
	}

	getBackOrderData(e) {
		const backOrderQty = this.modalHtml.querySelector(
			'input[name=stock-option]:checked',
		).value;

		if (parseInt(backOrderQty, 10)) {
			const sku = e.currentTarget.getAttribute('data-product-sku');
			const quantity = backOrderQty;

			this.addCartEntry(sku, quantity);
		}
	}

	getReplacementProductData() {
		const replacementProduct = this.modalHtml.querySelector(
			'#replacementProduct',
		);

		if (replacementProduct === null) {
			return;
		}

		const quantity = replacementProduct.querySelector('input[name=qty]').value;

		if (parseInt(quantity, 10)) {
			const sku = replacementProduct.getAttribute('data-product-sku');

			this.addCartEntry(sku, quantity);
		}
	}

	addCartEntry(sku, quantity) {
		const productData = {
			sku,
			quantity,
		};

		this.cartEntries.push(productData);
	}

	populateAddToCartModal() {
		const backOrderModel = this.isPremiumGift
			? addGiftBackOrderModel
			: addToCartBackOrderModel;

		return backOrderModel(this.cartEntries).then(result => {
			const { data } = result;

			this.modalInstance.insertResponse(data, this.addToCartModalId);

			// Claiming a gift changes the premium wallet, which lives on the page behind the modal.
			// Reload once the customer dismisses the success modal so the wallet reflects the claim.
			if (this.isPremiumGift) {
				this.reloadPageOnModalClose();
			}
		});
	}

	reloadPageOnModalClose() {
		this.modalInstance.modal.onHide(() => window.location.reload());
	}
}
